<template>
  <div class="par view" v-bind:style="{ backgroundImage: 'url(' + singlePhoto.thumburl + ')' }">
    <div v-on:click="close" class='close-but'>&#x2715;</div>
    <div class='user-caption'>
      <!--<div class='user-name'>{{singlePhoto.username}}</div>
      <div class='user-spot'>{{singlePhoto}}</div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'photo',
  data () {
    return {
      msg: 'Jag heter Pär och jag är bäst på javasscript'
    }
  },
  computed: {
    singlePhoto () {
      return this.$store.state.singlePhoto
    }
  },
  methods: {
    close () {
      this.$store.commit('setSinglePhoto', null)
    }
  },
  mounted () {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .view.par {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 999911;
    background-color: #000;
    color: #fff;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// photo.vue?6b76c53b